import { signOut } from "firebase/auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import SpinnerDot from "../../components/SpinnerDot";
import auth from "../../firebase/auth";
import useAxiosJwtQuery from "../../hooks/useAxiosJwtQuery";
import CancelConfirmationModal from "../../modals/CancelConfirmationModal";
import axiosJwt from "../../utils/axiosJwt";

export default function ManageOrders() {
  const navigate = useNavigate();
  const [modalId, setModalId] = useState(null);

  const [orders, refetch] = useAxiosJwtQuery(`/orders`);

  const handleStatusChange = (_id, event) => {
    const status = event.target.value;

    const newDetails = {
      _id,
      status,
    };

    axiosJwt
      .put(`${process.env.REACT_APP_SERVER_ENDPOINT}/orders`, newDetails)
      .then(({ data }) => {
        if (data.modifiedCount || data.upsertedCount || data.matchedCount) {
          toast.info("Updated Order Status Successfully");

          refetch();
        } else {
          toast.error("Couldn't Update Order Status");
        }
      })
      .catch((error) => {
        if ([401, 403].includes(error?.response?.status)) {
          signOut(auth);

          localStorage.removeItem("token");

          navigate("/login");
        }

        toast.error("Couldn't Update Order Status");
      });
  };

  return (
    <div class="w-auto">
      <div class="hero-content flex flex-col">
        {modalId && (
          <CancelConfirmationModal
            id={modalId}
            toast={toast}
            refetch={refetch}
          />
        )}

        <ToastContainer />

        <h1 class="text-center text-5xl font-bold">Manage Orders</h1>

        <div class="card flex-shrink-0 w-full">
          {!orders ? (
            <SpinnerDot />
          ) : !(orders?.length > 0) ? (
            <h1 class="text-center text-5xl text-[teal] font-bold">
              No orders found!
            </h1>
          ) : (
            <div class="overflow-x-auto">
              <table class="table w-fit mx-auto">
                <thead>
                  <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Quantity</th>
                    <th className="text-center">Status</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  {orders.map(({ _id, name, quantity, status }, i) => (
                    <tr key={_id}>
                      <th>{i + 1}</th>
                      <td>{name}</td>
                      <td className="text-center">{quantity}</td>
                      <td
                        className={`font-bold text-center ${
                          status === "UNPAID"
                            ? "text-yellow-500"
                            : status === "PAID"
                            ? "text-green-500"
                            : status === "PENDING"
                            ? "text-orange-500"
                            : "text-blue-500"
                        }`}
                      >
                        <select
                          onChange={(event) => {
                            handleStatusChange(_id, event);
                          }}
                          name="status"
                          id="status"
                          className="input input-bordered p-2"
                        >
                          <option value="UNPAID" selected={status === "UNPAID"}>
                            UNPAID
                          </option>

                          <option value="PAID" selected={status === "PAID"}>
                            PAID
                          </option>

                          <option
                            value="PENDING"
                            selected={status === "PENDING"}
                          >
                            PENDING
                          </option>

                          <option
                            value="SHIPPED"
                            selected={status === "SHIPPED"}
                          >
                            SHIPPED
                          </option>
                        </select>
                      </td>
                      <td>
                        <label
                          onClick={() => {
                            setModalId(_id);
                          }}
                          for={_id}
                          className="modal-button btn border-0 bg-red-600 hover:bg-red-700"
                        >
                          Cancel
                        </label>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
